import React from "react";

import destination_1 from "../../public/wheretogo-jeseniky/medvedivrch/destination_1.png";
import destination_2 from "../../public/wheretogo-jeseniky/medvedivrch/destination_2.png";
import destination_3 from "../../public/wheretogo-jeseniky/medvedivrch/destination_3.png";
import destination_4 from "../../public/wheretogo-jeseniky/medvedivrch/destination_4.png";
import destination_5 from "../../public/wheretogo-jeseniky/medvedivrch/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-jeseniky/medvedivrch/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-jeseniky/medvedivrch/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-jeseniky/medvedivrch/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-jeseniky/medvedivrch/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const MedvediVrch = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Medvědí vrch</h1>
            <p>
              Medvědí vrch v Hrubém Jeseníku se nachází mimo značených
              turistických cest, v nádherném kraji, kde ještě stále nepotkáte
              mnoho turistů. Torza suchých stromů a rozsáhlé vrchovištní mokřiny
              neumožňují příliš pohodlnou chůzi. Přesto, anebo právě proto, zde
              má člověk pocit dokonalé izolace, ruch nedalekých turistických
              center sem nedolehne.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lanovka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>rohledna</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>horské kolo</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Rozhledna na Medvědí hoře u Tetřeví chaty se tyčí do výšky
                  18m. Do krajiny na hřebeny Jeseníků se můžete dívat nejen z
                  horní plošiny, ale i z průhledů a balkonů, které se nachází na
                  obvodu stavby.
                </li>
                <li>
                  Medvědí hora je součástí lyžařského areálu Kouty, který
                  funguje nedaleko Loučné nad Děsnou, rozhledna stojí 40 metrů
                  od výstupní stanice lanovky. V okolí Medvědí hory se nachází
                  naučná stezka, vede tudy i nová turistická trasa z Kout na
                  Malou Jezernou.
                </li>
                <li>
                  Předmětem ochrany je zbytek horského smíšeného suťového lesa s
                  četnými zbytky přirozených květnatých Bučin s
                  charakteristickou floristickou skladbou a druhově bohatou
                  avifaunou.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MedvediVrch;
